import {Text, useWindowDimensions, View} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import strings from '../../../translations';
import styleSheet from './styles';
import {ReactionDataForChart, SpeakerDataForChartType} from '../customChart';
import {useAnalyticsStore} from 'contexts/StoreContext';
import {CreateChartProps} from '.';

const CreateChart = (props: CreateChartProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);
  const {width} = useWindowDimensions();
  const analyticStore = useAnalyticsStore();

  const basicStartOffset = width / 200;
  const domain = 100;

  let speakersChart;
  let reactionsChart;

  switch (props.chartType) {
    case strings.analyticsScreen.speakers:
      speakersChart = analyticStore.selectedTranscriptionChartData.map(
        (bar, index) => {
          return (
            <View
              key={index}
              style={[
                styles.defaultStyle,
                styles.defaultChartValueStyleWeb(props.chartType),
                styles.speakerBarStyle(
                  domain,
                  bar.startOffset,
                  basicStartOffset,
                  bar.endOffset,
                ),
              ]}>
              <View style={styles.beforeViewStyle} />
            </View>
          );
        },
      );

    case strings.analyticsScreen.reaction:
      reactionsChart = analyticStore.selectedReactionChartData.map(
        (bar, index) => {
          return (
            <View
              key={index}
              style={[
                styles.defaultStyle,
                styles.defaultChartValueStyleWeb(props.chartType),
                styles.reactionBarStyle(domain, bar.offset, basicStartOffset),
              ]}>
              <Text style={styles.reactionSize}>{bar.reaction}</Text>
            </View>
          );
        },
      );
  }

  return (
    <>
      {speakersChart}
      {reactionsChart}
    </>
  );
};

export default CreateChart;
